import { clsx as e } from "clsx";
import { extendTailwindMerge as t } from "tailwind-merge";
//#region src/lib/utils.ts
var n = t({ extend: { classGroups: { "font-size": [{ text: ["btn"] }] } } });
function r(...t) {
	return n(e(t));
}
//#endregion
export { r as t };

//# sourceMappingURL=utils-DQJjwn-K.js.map